import React, { Component } from "react";
import ShareIcon from "src/img/new/share.svg";
import FavouritesIcon from "src/img/new/favourites.svg";
import PlaybackIcon from "src/img/new/playback.svg";
import ImgPhoneFrame from "src/img/customise/ImgPhoneFrame.png";
import ImgBackground from "src/img/customise/ImgBackground.png";
import ImgQuotesOverlay from "src/img/customise/ImgQuotesOverlay.png";
import ImgQuotesPrimary from "src/img/customise/ImgQuotesPrimary.png";
import ImgQuotesSecondary from "src/img/customise/ImgQuotesSecondary.png";
import ImgYourLogoHere from "src/img/customise/ImgYourLogoHere.png";
import { Text, FlexContainer } from "src/components";
import { Screens } from "../../constants";
import { isArticleEmpty, ArticleDescriptionSentences } from "../../utils";
import { AutoResizingQuoteText } from "./AutoResizingQuoteText";
import {
    WidthContainer, ImageLayer,
    FooterSection, InfoCard, IconCard, ProfileImage,
    IconImage, PlainImageLayer, PlainImageTextLayer,
    BackgroundLayer, PrimaryLayer, SecondaryLayer,
    MainQuotesDisplay, MainQuoteCard,
    ZeroSizeSvg, ArticleLayer, ArticleHeader, ArticleContent,
    ArticleImageRow, ArticleImageColumn, TopPositionContainer, 
    CrossButton, ArticleHeaderBar,
} from "./style";

const SIZING = {
    FRAME_WIDTH: 302,
    FRAME_HEIGHT: 614,
    SCREEN_WIDTH: 289,
    SCREEN_HEIGHT: 594,
};

const getLayout = (w, h, offsetX = 0, offsetY = 0) => ({
    width: w,
    height: h,
    left: offsetX,
    top: offsetY
});

const SvgFilter = ({ filterId, rgbValues }) => {
    const matrix = `0 0 0 0 ${rgbValues[0]} 0 0 0 0 ${rgbValues[1]} 0 0 0 0 ${rgbValues[2]} 0 0 0 1 0`;
    return (
        <filter id={filterId} colorInterpolationFilters="sRGB">
            <feColorMatrix type="matrix" values={matrix} />
        </filter>
    );
};

class PreviewDisplay extends Component {
    renderLayers = (screen) => {
        const { formData, logoUrl } = this.props;
        const isEmpty = isArticleEmpty(formData.article);
        const isArticleImageEmpty = !formData.objectImage.article;

        const screenLayout = getLayout(
            SIZING.SCREEN_WIDTH,
            SIZING.SCREEN_HEIGHT,
            (SIZING.FRAME_WIDTH - SIZING.SCREEN_WIDTH) / 2,
            (SIZING.FRAME_HEIGHT - SIZING.SCREEN_HEIGHT) / 2
        );
        const phoneLayout = getLayout(SIZING.FRAME_WIDTH, SIZING.FRAME_HEIGHT);
        const logoAspect = 3.43;
        const logoWidth = SIZING.FRAME_WIDTH / 2;
        const logoHeight = Math.floor(logoWidth / logoAspect);
        const logoLayout = getLayout(
            logoWidth,
            logoHeight - logoHeight / 5,
            screen !== Screens.SPLASH ? SIZING.FRAME_WIDTH / 12 : (SIZING.FRAME_WIDTH - logoWidth) / 2,
            (screen === Screens.MAIN ? SIZING.FRAME_HEIGHT / 8.5 : SIZING.FRAME_HEIGHT / 2.2) - logoHeight / 2
        );

        const logoSrc = logoUrl && !logoUrl.startsWith("?") ? logoUrl : ImgYourLogoHere;

        switch (screen) {
        case Screens.MAIN:
            return [
                <BackgroundLayer key="bg" layout={screenLayout} src={ImgBackground} />,
                <PrimaryLayer key="primary" layout={screenLayout} src={ImgQuotesPrimary} />,
                <SecondaryLayer key="secondary" layout={screenLayout} src={ImgQuotesSecondary} />,
                <PlainImageLayer key="overlay" layout={screenLayout} src={ImgQuotesOverlay} />,
                <PlainImageTextLayer key="logo" layout={logoLayout} src={logoSrc} position="left" />,
                <PlainImageLayer key="frame" layout={phoneLayout} src={ImgPhoneFrame} />,
                <MainQuotesDisplay key="quoteOverlay" layout={screenLayout} position="absolute"/>, // Covers overlay with color while image is loading, especially when editing multiple times in a single quote
                <MainQuotesDisplay key="quoteDisplay" layout={screenLayout} src={formData.objectImage.quotes}>
                    <AutoResizingQuoteText {...formData.customization} height="70%">
                        {formData.quoteText || "Quote text here"}
                    </AutoResizingQuoteText>
                    {((formData.objectImage.quotes || formData.quoteText) && (!isEmpty || !isArticleImageEmpty)) && (
                        <MainQuoteCard>
                            <Text size=".50rem" textAlign="center">Read the article &nbsp; ❯</Text>
                        </MainQuoteCard>
                    )}
                </MainQuotesDisplay>
            ];

        case Screens.QUOTES:
            return [
                <BackgroundLayer key="bg" layout={screenLayout} src={ImgBackground} />,
                <ImageLayer key="img" layout={screenLayout} src={formData.objectImage.quotes}>
                    <CrossButton position="absolute" color="#fff" top="40px" right="32px" fontSize="30px">× </CrossButton>
                    <TopPositionContainer
                        verticalAlign={formData.customization.verticalAlign}
                        textAlign={formData.customization.textAlign}
                    >
                        <AutoResizingQuoteText
                            {...formData.customization} width="250px" height="100%"  
                            showBorder={true}
                            isQuoteScreen={true}
                        >
                            {formData.quoteText || "Quote text here"}
                        </AutoResizingQuoteText>
                    </TopPositionContainer>

                    <FooterSection>
                        {(!isEmpty || !isArticleImageEmpty) && (
                            <InfoCard >
                                {!isArticleImageEmpty && (<ProfileImage src={formData.objectImage.article} />)}
                                <FlexContainer direction="col" >
                                    <Text size=".80rem" weight="bold" align="left" margin={`0 0 0 ${ isArticleImageEmpty ? ".50em" : "0"}`}>
                                        Read the article
                                    </Text>
                                    <Text size="0.70rem" weight="500" align="left" margin={`0 0 0 ${ isArticleImageEmpty ? ".50em" : "0"}`}>
                                        {formData.article.title?.slice(0, 30) || "Enter article title"}
                                        {formData.article.title?.length > 30 ? "..." : ""}
                                    </Text>
                                </FlexContainer>
                            </InfoCard>
                        )}
                        <IconCard>
                            <IconImage src={ShareIcon} />
                            <IconImage src={FavouritesIcon} />
                            <IconImage src={PlaybackIcon} />
                        </IconCard>
                    </FooterSection>
                </ImageLayer>,
                <PlainImageLayer key="frame" layout={phoneLayout} src={ImgPhoneFrame} />
            ];
        case Screens.ARTICLES:
            if (!isEmpty || !isArticleImageEmpty) {
                const countSentences = (text) => {
                    return text
                        .split(".")
                        .filter(sentence => sentence.trim() !== "").length;
                };
                const articleText = formData.article.articleHtml || "Enter Article Description";
                const sentenceCount = countSentences(articleText);
                const sliceLimit = sentenceCount >= 3 ? 220 : 250;
                const showMoreNeeded = articleText.length > sliceLimit;
                const displayText = showMoreNeeded ? articleText.slice(0, sliceLimit) : articleText;

                return [
                    <BackgroundLayer key="bg" layout={screenLayout} src={ImgBackground} />,
                    <ArticleLayer key="article" layout={screenLayout} overflowY={isArticleImageEmpty ? "scroll" : "hidden"}>
                        <ArticleHeaderBar>
                            {"Article"}
                            <CrossButton top="5px">×</CrossButton>
                        </ArticleHeaderBar>
                        
                        <ArticleHeader>{formData.article.title || "Enter Article Title"}</ArticleHeader>
                        { !isArticleImageEmpty ? (
                            <>
                                <ArticleContent>
                                    <ArticleDescriptionSentences text={displayText} space="0.8em" />
                                    {showMoreNeeded && (
                                        <> 
                                            <span>...</span>
                                            <Text color="#000" align="left" weight="bold"> Show more</Text>
                                        </>
                                    )}
                                </ArticleContent>
                                <ArticleImageRow>
                                    <ArticleImageColumn flex={10} bgImage={formData.objectImage.article}>
                                        {!formData.objectImage.article && "Upload Image"}
                                    </ArticleImageColumn>
                                </ArticleImageRow>
                            </>
                        ) : (
                            <ArticleContent>
                                <ArticleDescriptionSentences text={formData.article.articleHtml || "Enter Article Description"} space="0.8em" />
                            </ArticleContent>
                        )}
                    </ArticleLayer>,
                    <PlainImageLayer key="frame" layout={phoneLayout} src={ImgPhoneFrame} />
                ];
            }
            break;
        default:
            return null;
        }
    };

    render() {
        const { currentScreen, colourPalette } = this.props;
        const { primaryColor, secondaryColor, backgroundColor } = colourPalette;

        return (
            <WidthContainer>
                {this.renderLayers(currentScreen)}
                <ZeroSizeSvg>
                    <SvgFilter filterId="filter-primary" rgbValues={primaryColor} />
                    <SvgFilter filterId="filter-secondary" rgbValues={secondaryColor} />
                    <SvgFilter filterId="filter-background" rgbValues={backgroundColor} />
                </ZeroSizeSvg>
            </WidthContainer>
        );
    }
}

export default PreviewDisplay;
